export const px = scalar => scalar + "px"
export const em = scalar => scalar + "em"
